module.exports = __webpack_public_path__ + "img/teacher-default.a44d5938.png";